<template>
    <div class="bg-theme-card border border-theme-border rounded-xl p-4">
        <label
            class="flex items-center gap-1 text-sm font-medium text-theme-base"
        >
            <img
                v-if="icon"
                :src="icon"
                :alt="label"
                class="w-5 h-5 object-contain flex-shrink-0"
            />
            <span>{{ label }}</span>
        </label>

        <div
            class="flex items-stretch mt-2 overflow-hidden rounded-lg border border-theme-border bg-theme-input focus-within:ring-2 focus-within:ring-brand-red focus-within:border-brand-red transition"
        >
            <span
                class="flex items-center px-3 text-xs text-theme-muted bg-theme-hover border-r border-theme-border whitespace-nowrap select-none"
            >
                {{ baseUrl }}
            </span>

            <input
                v-model="username"
                :placeholder="placeholder"
                autocomplete="off"
                spellcheck="false"
                autocapitalize="off"
                autocorrect="off"
                class="flex-1 px-3 py-2 text-sm bg-transparent text-theme-base outline-none lowercase"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "SocialNetworkUrlInput",

    props: {
        value: {
            type: String,
            default: ""
        },
        label: {
            type: String,
            required: true
        },
        icon: {
            type: String,
            default: ""
        },
        baseUrl: {
            type: String,
            required: true
        },
        placeholder: {
            type: String,
            default: ""
        }
    },

    methods: {
        sanitize(value) {
            let username = (value || "").trim();

            // Si pega una URL completa
            username = username.replace(/^https?:\/\//i, "");
            username = username.replace(/^www\./i, "");

            // Elimina la URL base si viene incluida
            const cleanBase = this.baseUrl
                .replace(/^https?:\/\//i, "")
                .replace(/\/$/, "");

            if (username.toLowerCase().startsWith(cleanBase.toLowerCase())) {
                username = username.substring(cleanBase.length);
            }

            // Elimina slash inicial
            username = username.replace(/^\/+/, "");

            return username;
        }
    },

    computed: {
        username: {
            get() {
                return this.sanitize(
                    this.value.startsWith(this.baseUrl)
                        ? this.value.slice(this.baseUrl.length)
                        : this.value
                );
            },

            set(value) {
                const username = this.sanitize(value);

                this.$emit(
                    "input",
                    username ? `${this.baseUrl}${username}` : ""
                );
            }
        }
    }
};
</script>
